import { PartialRecord } from '../../../common'

export enum ProductCategory {
  BREAD = 'BREAD',
  MEAT = 'MEAT',
  FATS = 'FATS',
  VEGETABLES = 'VEGETABLES',
  SALT = 'SALT',
  GROATS = 'GROATS',
  FISH = 'FISH',
  MILK = 'MILK',
  SUGAR = 'SUGAR',
  EGGS = 'EGGS',
  TOILET_SOAP = 'TOILET_SOAP',
  LAUNDRY_SOAP = 'LAUNDRY_SOAP',
  DETERGENTS = 'DETERGENTS',
  MATCHES = 'MATCHES',
  KEROSENE = 'KEROSENE',
}

export interface ProductCategoryInfo {
  shorthand: string
  description: string
  kind: 'food' | 'item'
}

export const PRODUCT_CATEGORIES_ACTUAL_COMSUMPTION_COEFFICIENTS: Record<ProductCategory, number> = {
  [ProductCategory.EGGS]: 0.000_001,
  [ProductCategory.BREAD]: 0.000_001,
  [ProductCategory.MEAT]: 0.000_001,
  [ProductCategory.FATS]: 0.000_001,
  [ProductCategory.VEGETABLES]: 0.000_001,
  [ProductCategory.SALT]: 0.000_001,
  [ProductCategory.GROATS]: 0.000_001,
  [ProductCategory.FISH]: 0.000_001,
  [ProductCategory.MILK]: 0.001,
  [ProductCategory.SUGAR]: 0.000_001,
  [ProductCategory.TOILET_SOAP]: 0.000_001,
  [ProductCategory.LAUNDRY_SOAP]: 0.000_001,
  [ProductCategory.DETERGENTS]: 0.000_001,
  [ProductCategory.MATCHES]: 0.000_001,
  [ProductCategory.KEROSENE]: 0.000_8,
}

export const PRODUCT_CATEGORIES_HANDBOOKS_UNITS: PartialRecord<ProductCategory, string> = {
  [ProductCategory.EGGS]: '(шт)',
  [ProductCategory.MILK]: '(л)',
  [ProductCategory.MATCHES]: '(шт)',
  [ProductCategory.KEROSENE]: '(л)',
}

export const PRODUCT_CATEGORIES_HANDBOOKS_UNITS_FULL: Record<ProductCategory, string> = {
  [ProductCategory.EGGS]: '(шт)',
  [ProductCategory.MILK]: '(л)',
  [ProductCategory.MATCHES]: '(шт)',
  [ProductCategory.KEROSENE]: '(л)',
  [ProductCategory.BREAD]: '(г)',
  [ProductCategory.MEAT]: '(г)',
  [ProductCategory.FATS]: '(г)',
  [ProductCategory.VEGETABLES]: '(г)',
  [ProductCategory.SALT]: '(г)',
  [ProductCategory.GROATS]: '(г)',
  [ProductCategory.FISH]: '(г)',
  [ProductCategory.SUGAR]: '(г)',
  [ProductCategory.TOILET_SOAP]: '(г)',
  [ProductCategory.LAUNDRY_SOAP]: '(г)',
  [ProductCategory.DETERGENTS]: '(г)',
}

export const PRODUCT_CATEGORIES_REPORTS_UNITS: PartialRecord<ProductCategory, string> = {
  [ProductCategory.EGGS]: '(млн. шт)',
  [ProductCategory.MATCHES]: '(млн. шт)',
}

export const PRODUCT_CATEGORIES_REPORTS_UNITS_FULL: Record<ProductCategory, string> = {
  [ProductCategory.EGGS]: '(млн. шт)',
  [ProductCategory.MATCHES]: '(млн. шт)',
  [ProductCategory.BREAD]: '(т)',
  [ProductCategory.MEAT]: '(т)',
  [ProductCategory.FATS]: '(т)',
  [ProductCategory.VEGETABLES]: '(т)',
  [ProductCategory.SALT]: '(т)',
  [ProductCategory.GROATS]: '(т)',
  [ProductCategory.FISH]: '(т)',
  [ProductCategory.MILK]: '(т)',
  [ProductCategory.SUGAR]: '(т)',
  [ProductCategory.TOILET_SOAP]: '(т)',
  [ProductCategory.LAUNDRY_SOAP]: '(т)',
  [ProductCategory.DETERGENTS]: '(т)',
  [ProductCategory.KEROSENE]: '(т)',
}

export const PRODUCT_CATEGORIES_INFO: Record<ProductCategory, ProductCategoryInfo> = {
  [ProductCategory.BREAD]: {
    shorthand: 'Х',
    description: 'Хлеб (мука)',
    kind: 'food',
  },
  [ProductCategory.MEAT]: {
    shorthand: 'М',
    description: 'Мясо',
    kind: 'food',
  },
  [ProductCategory.FATS]: {
    shorthand: 'Ж',
    description: 'Жиры',
    kind: 'food',
  },
  [ProductCategory.VEGETABLES]: {
    shorthand: 'КО',
    description: 'Картофель, овощи',
    kind: 'food',
  },
  [ProductCategory.SALT]: {
    shorthand: 'S',
    description: 'Соль',
    kind: 'food',
  },
  [ProductCategory.GROATS]: {
    shorthand: 'Кр',
    description: 'Крупа',
    kind: 'food',
  },
  [ProductCategory.FISH]: {
    shorthand: 'Р',
    description: 'Рыба',
    kind: 'food',
  },
  [ProductCategory.MILK]: {
    shorthand: 'М/П',
    description: 'Молоко',
    kind: 'food',
  },
  [ProductCategory.SUGAR]: {
    shorthand: 'С',
    description: 'Сахар',
    kind: 'food',
  },
  [ProductCategory.EGGS]: {
    shorthand: 'Я',
    description: 'Яйцо',
    kind: 'food',
  },
  [ProductCategory.TOILET_SOAP]: {
    shorthand: 'ТМ',
    description: 'Мыло туалетное',
    kind: 'item',
  },
  [ProductCategory.LAUNDRY_SOAP]: {
    shorthand: 'ХМ',
    description: 'Мыло хозяйственное',
    kind: 'item',
  },
  [ProductCategory.DETERGENTS]: {
    shorthand: 'СМС',
    description: 'Средства моющие синтетические',
    kind: 'item',
  },
  [ProductCategory.MATCHES]: {
    shorthand: 'Спички',
    description: 'Спички',
    kind: 'item',
  },
  [ProductCategory.KEROSENE]: {
    shorthand: 'Керосин',
    description: 'Керосин',
    kind: 'item',
  },
}
